import React, { useState } from "react";
import { FaTimes, FaInfoCircle } from "react-icons/fa";
import { BulkAddTags } from "../../../../services/ProductService/AllProductList/AllProductServices";

const BulkAddTagsPopup = ({ onClose, onSelectedId }) => {
    const [tags, setTags] = useState([]);
    const [inputValue, setInputValue] = useState("");
    const [loading, setLoading] = useState(false);

    // Convert tags array to a comma-separated string
    const tagsString = tags.join(", ");

    const handleKeyDown = (e) => {
        if (e.key === "Enter" && inputValue.trim() !== "") {
            setTags([...tags, inputValue.trim()]);
            setInputValue("");
            e.preventDefault(); // Prevent new line in textarea
        }
    };

    const handleRemoveTag = (tagToRemove) => {
        setTags(tags.filter((tag) => tag !== tagToRemove));
    };

    const handleAddTags = async() => {
        if (tags.length > 0) {
            const data = {product_ids:onSelectedId,tag:tagsString}
            
            try {
                await BulkAddTags('POST', data);
                onClose();
            } catch (error) {
                console.error("Error exporting selected columns:", error);
            } finally {
                setLoading(false);
            }
        }
        onClose();
    };

    return (
        <div className="fixed inset-0 bg-gray-900 bg-opacity-50 flex items-center justify-center">
            <div className="bg-white p-6 rounded-lg shadow-lg w-1/3">
                <div className="flex justify-between items-start border-b pb-3">
                    <div className="flex items-center gap-2">
                        <FaInfoCircle className="text-blue-500" />
                        <h2 className="text-lg font-semibold">Add Tags</h2>
                    </div>
                    <button onClick={onClose} className="text-gray-500 hover:text-gray-700 text-xl font-bold">
                        <FaTimes />
                    </button>
                </div>

                <p className="text-sm text-gray-500 mt-3">
                    You can add multiple tags to find buyers and press <b>Enter</b> for the next tag.
                </p>

                <div className="border p-3 rounded-lg mt-3 min-h-[80px] flex flex-wrap gap-2">
                    {tags.map((tag, index) => (
                        <span key={index} className="bg-blue-200 text-blue-800 px-2 py-1 rounded flex items-center">
                            {tag}
                            <button onClick={() => handleRemoveTag(tag)} className="ml-2 text-red-500">
                                ×
                            </button>
                        </span>
                    ))}
                    <input
                        type="text"
                        placeholder="Enter ..."
                        value={inputValue}
                        onChange={(e) => setInputValue(e.target.value)}
                        onKeyDown={handleKeyDown}
                        className="border-none outline-none flex-1 min-w-[50px]"
                    />
                </div>

                <div className="flex justify-end mt-4">
                    <button
                        onClick={handleAddTags}
                        className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
                    >
                        {loading ? "Adding Tags..." : "Add Tags"}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default BulkAddTagsPopup;
